module.exports = __webpack_public_path__ + "img/alex.c7050f81.svg";